import React from "react";
import { Card, Grid, Icon, Image } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import _, { lowerCase } from "lodash";

import cx from "classnames";
import dateformat from "dateformat";

import { fetchAccount } from "actions/accounts";
import { fetchUsers } from "actions/users";

import styles from "./account_card.module.scss";
import { fetchAdminAppUsers } from "actions/users";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function AccountCard({ account }) {
  
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const params = useParams();

  const icon = _.get(account, "logo", "/images/default_account_background.png");
  const createdDate = account?.createdDate ? Number(account.createdDate) : null;

  const getSubscriptionStyle = (subscription) => {
    let subscriptionStyle = styles.subscriptionStyle;

    switch (subscription) {
      case "trial":
        subscriptionStyle += ` ${styles.TRIAL}`;
        break;
      case "paid":
        subscriptionStyle += ` ${styles.PAID}`;
        break;
      case "suspended":
        subscriptionStyle += ` ${styles.SUSPENDED}`;
        break;
      case "terminated":
        subscriptionStyle += ` ${styles.TERMINATED}`;
        break;
      default:
        break;
    }
    return subscriptionStyle;
  };


  const navigateToAccountDetail = (account) => {
    dispatch(fetchAdminAppUsers());
    dispatch(fetchAccount({ id: account.id }));
    dispatch(fetchUsers({ page: 0, limit: 20, filters: { account: account.id, refresh: true } }));

    let { product } = params;
    let path = `/${product}/accounts/${account.id}/management`;

    history.push({
      pathname: path,
      state: { account },
    });
  };

  return (
    <Card
      raised={true}
      className={cx(styles.card)}
      onClick={() => navigateToAccountDetail(account)}
      key={account.id}
    >
      <Card.Content>
        <Grid>
          <Grid.Row className={cx(styles.accountStyle)}>
            <Grid.Column className={styles.accountDetails} width={10}>
              <div className={cx(styles.logo)}>
                <Image className={cx(styles.image)} src={icon} circular />
              </div>
              <div className={cx(styles.account)}>
                <span className={cx(styles.title)} title={account.name}>
                  {account.name}
                </span>
              </div>
            </Grid.Column>
            <Grid.Column width={6} textAlign="left">
              <div className={cx(getSubscriptionStyle(account.subscription))}>
                <Icon name="circle" className={cx(styles.icon)} />
                {(account.subscription)}
              </div>
              <div className={cx(styles.date)}>
                {createdDate ? dateformat(createdDate, "dd-mmm-yyyy") : "-"}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={3} className={cx(styles.statsStyle)}>
            <Grid.Column>
              <div className={cx(styles.stats)}>{account.totalUsers}</div>
              <div className={cx(styles.label)}>Total Users</div>
            </Grid.Column>
            <Grid.Column>
            <div className={cx(styles.stats)}>{account.activeUsers}</div>
              <div className={cx(styles.label)}>Active Users</div>
            </Grid.Column>
            <Grid.Column>
              <div className={cx(styles.stats)}>{account.pendingInvitations}</div>
              <div className={cx(styles.label)}>Pending Invitations</div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
}
